<template>
  <v-card class="base-card d-flex d-inline-flex w-full">
    <v-card-text>
      <UISliderLine v-if="!mini" id="sliderLine" :items="newsList.list" :width="350" />
      <div
        v-else
        id="sliderLine"
        class="minSliderLine d-flex flex-column align-center"
        style="cursor: pointer"
        @click="$route.name !== 'newsPage' && $router.push('/spm/news')"
      >
        <v-icon class="uikit-icon news-icon mb-3" />
        <strong v-for="(l, index) in 'НОВОСТИ'.split('')" :key="index" class="mb-1">{{ l }}</strong>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import UISliderLine from '@/ui/slider/UISliderLine'
import { NewsList } from '@/models'
import { newsApi } from '@/api'
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'NewsLine',
  components: { UISliderLine },

  props: {
    mini: {
      type: Boolean,
      default: false,
    },
  },

  updated() {
    this.$nextTick(() => {
      this.setHeightNewsLine()
    })
  },

  mounted() {
    if (this.isXs) {
      this.setIsShowFullNews(true)
    }
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize)
    })
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.onResize)
  },

  async created() {
    await this.getNewsList()
  },

  data: () => ({
    newsList: new NewsList(),
    windowHeight: window.innerHeight,
  }),

  computed: {
    ...mapGetters('settings', ['isShowFullNews']),
    ...mapGetters('breakpoint', ['isXs']),
  },

  methods: {
    ...mapActions('settings', ['setIsShowFullNews']),

    switchIsShowFullNews() {
      this.setIsShowFullNews(!this.isShowFullNews)
    },

    onResize() {
      this.windowHeight = window.innerHeight
    },

    setHeightNewsLine() {
      if (document.getElementById('sliderLine')) {
        const heightTopMenu = document.getElementById('menu').clientHeight + 100
        // 32 - сумма верхних и нижних padding у новостного блока
        // 44 - высота footer
        // 20 - отступ между footer и основной рабочей областью
        const heightNewsLine = window.innerHeight - heightTopMenu - 32 - 44 - 20

        document.getElementById('sliderLine').style.height = `${heightNewsLine}px`
      }
    },

    async getNewsList() {
      try {
        const content = await newsApi.getCatalog()
        this.newsList = new NewsList()

        content.length && content.forEach((obj) => this.newsList.add(obj))
      } catch (e) {
        this.showErrorMessage(e, 'Ошибка получения новостей')
      }
    },
  },

  watch: {
    windowHeight() {
      this.setHeightNewsLine()
    },
  },
}
</script>

<style lang="scss" scoped>
.minSliderLine {
  overflow: hidden;
}

@media (max-height: 710px) {
  .minSliderLine {
    justify-content: center;
  }
  .minSliderLine .news-icon {
    display: none;
  }
  .minSliderLine strong {
    margin-bottom: 0 !important;
  }
}
</style>
